import Swiper, { Pagination } from 'swiper'
Swiper.use([Pagination])

import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'

for (let sliderElement of document.querySelectorAll('.posts-slider')) {
  let swiper = new Swiper(sliderElement.querySelector('.swiper'), {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  })
  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)
}
